import _taggedTemplateLiteralLoose from 'babel-runtime/helpers/taggedTemplateLiteralLoose';

var _templateObject = _taggedTemplateLiteralLoose(['\n  query featureFlags {\n    featureFlags {\n      id\n      feature\n    }\n  }\n'], ['\n  query featureFlags {\n    featureFlags {\n      id\n      feature\n    }\n  }\n']);

import gql from 'graphql-tag';

export var FeatureFlagsQuery = gql(_templateObject);